import React from 'react'
import { useSearchParams } from 'react-router-dom'
import PlatformOverviewPage from './overview/PlatformOverviewPage'
import Dashboard from './Dashboard'

/**
 * `/` index: platform overview when no tab; workspace tabs otherwise.
 */
export default function MainIndex() {
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')

  if (!tab) {
    return <PlatformOverviewPage />
  }

  return <Dashboard />
}
